module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0078.jpg?v=8eedf29f";